// The Programs page and Week at a Glance share one pair of filters — program
// status and main PM (Edward, 2026-11-04) — so the matching rules live here once.
// The PM filter matches the primary PM only; supporting PMs are deliberately not
// part of it. PM_NONE selects programs with no PM assigned.

export const PM_NONE = 'none';

// Programs' payload nests the PM (`program_manager.name`); Week at a Glance's
// flattens it (`program_manager_name`).
export const pmNameOf = (p) => p.program_manager?.name ?? p.program_manager_name ?? null;

export function filterPrograms(programs, { status, pm }) {
  return programs.filter(p => (
    (!status || p.status === status)
    && (!pm || (pm === PM_NONE ? !p.program_manager_id : String(p.program_manager_id) === String(pm)))
  ));
}

// Only PMs who are the main PM of some program are worth offering, sorted by name.
export function pmOptionsFrom(programs) {
  const byId = new Map();
  programs.forEach(p => {
    if (p.program_manager_id && !byId.has(p.program_manager_id)) {
      byId.set(p.program_manager_id, pmNameOf(p) || `User #${p.program_manager_id}`);
    }
  });
  return [...byId].map(([id, name]) => ({ value: String(id), label: name }))
    .sort((a, b) => a.label.localeCompare(b.label));
}
